import {adminApi} from 'sources/api';
import DepartmentSource from 'sources/DepartmentSource';
import AuthStore from 'stores/AuthStore';
import {associateBy} from 'utils/associateBy';
import {Set} from 'immutable';

export default class DepartmentFilterSource {
  static fetchAllDepartments(overwriteCookie = false) {
    const sessionUser = AuthStore.getState().user;
    const idsPromise = adminApi
      .getJson(`/users/${sessionUser.id}`)
      .then(editUser =>
        Set(editUser.permissions.departmentStatPermissions.map(p => p.departmentId))
      );

    const isAdmin = sessionUser.isAdmin();
    const deptsPromise = DepartmentSource.fetchDepartmentProfiles(isAdmin).then(departments =>
      associateBy(departments, d => d.id)
    );

    return Promise.all([idsPromise, deptsPromise, isAdmin, overwriteCookie]);
  }
}
